import React from "react";

export default function Goal({complete, remaining}: { complete: number, remaining: number }) {
    return (
        <div className="calender-header ">
            <h4>{complete}/ 1M Words </h4>
            <h1>Word Tracker</h1>
            <h4>Remaining: {remaining}</h4>
        </div>
    );
}